import styled, { css, FlattenSimpleInterpolation } from 'styled-components';
import { SkeletonProps, SkeletonColors } from './skeleton.types';
import { MLBTheme } from '../../style/theme.types';
import COLORS from '../../style/universal.color';

const { transparent } = COLORS;
const getRadius: Function = ({ isCircle, borderRadius }: SkeletonProps): string => (
  isCircle ? '50%' : `${borderRadius}px`
);

const getBackgroundColor: Function = (theme: MLBTheme, animation: boolean): FlattenSimpleInterpolation => {
  const type: string = (theme && theme.dark) ? 'dark' : 'primary';
  const bg: string = SkeletonColors[type].main;
  const bgHl: string = SkeletonColors[type].highlight;
  return (animation)
  ? css`
    linear-gradient(90deg, ${bg}, ${bgHl}, ${bg});
    background-color: ${bg}
  ` : css`
    ${transparent};
    background-color: ${bg}
  `;
};

const isLoadingOff: Function = (isLoading: boolean): boolean => (
  typeof isLoading !== 'undefined' && isLoading == false
);

const getPx: Function = (val: string | number): string | number => (
  (val) ? typeof val === 'string' ? val : `${val}px` : 'auto'
);

export const StyledBaseSkeleton = styled.div`
    height: ${({ height }: SkeletonProps) => getPx(height)};
    width: ${({ width }: SkeletonProps) =>  getPx(width)};

    background: ${({ isLoading, theme = {}, animation }: SkeletonProps) => 
      typeof isLoading === 'undefined' || isLoading ? getBackgroundColor(theme, animation) : transparent};
    background-size: ${({ isLoading }: SkeletonProps) => isLoadingOff(isLoading) ? 'auto auto' : '200px 100%'};
    
    border-radius: ${(props: SkeletonProps) => getRadius(props)};
    margin-bottom: ${({ margin }: SkeletonProps) => getPx(margin)};

    background-repeat: no-repeat;
    &:last-child {
        margin-bottom: ${({ margin }: SkeletonProps) => margin ? getPx(margin) : 0};
    }
    &.is-loading {
        > span  {
           display: none;
        }
    }

    animation: ${({ animation, isLoading }: SkeletonProps) => (isLoadingOff(isLoading) || !animation) ? 'none' : 'pulse 1.2s infinite ease-in-out'};
    @keyframes pulse {
        0% {
            background-position: -200px 0;
        }
        100% {
            background-position: calc(200px + 100%) 0;
        }
    } 
`;

